import store from '@/store'
import { geolocation } from '@/plugins/geolocation'

const checkActivityUser = async () => {
  if (!store.state.common.notificationAllow) {
    requestNotificationPermission()
  }

  if (!store.state.session.sessionId && store.state.common.deviceId) {
    store.dispatch('createSession')
  }
  checkGeolocationUser()
  store.dispatch('resetSessionTimeout')
}

const checkGeolocationUser = async () => {
  await geolocation()
}

const requestNotificationPermission = () => {
  if ('Notification' in window) {
    Notification.requestPermission()
      .then(function (permission) {
        if (permission === 'granted') {
          store.dispatch('notificationGranted', true)
          console.log('Notification permission granted.')
        } else {
          console.log('Notification permission not granted.')
        }
      })
      .catch(function (err) {
        console.error('Error requesting notification permission:', err)
      })
  } else {
    console.log('The browser does not support push notifications.')
  }
}

export default checkActivityUser
